import { configureStore } from "@reduxjs/toolkit";
import chatSlice from '../slice/chatSlice'
import textPopUpSlice from "../slice/textPopUp";
const store = configureStore({
    reducer: {
        chat: chatSlice,
        text: textPopUpSlice
    }
})
export default store